import styled from 'styled-components';
import { borderRadius } from 'styled-system';
import { COMMON, LAYOUT } from '../constants';
const Box = styled.div.withConfig({
  displayName: "Box",
  componentId: "oxpxda-0"
})(["", ";", ";", ";"], COMMON, LAYOUT, borderRadius);
Box.propTypes = { ...LAYOUT.propTypes,
  ...COMMON.propTypes,
  ...borderRadius.propTypes
};
Box.displayName = 'Box';
export default Box;